// import { createStore, combineReducers } from 'redux'
// import Mode from './setting/setting'
// export default createStore(
//     combineReducers({
//         mode: Mode
//     })
// )
import modal from "../services/redux/reducers/modalSlice";
import section from "../services/redux/reducers/sectionSlice";
import { configureStore } from "@reduxjs/toolkit";
import settingReducer from "./setting/reducers";
import customFormBuilder from "../services/redux/reducers/customFormBuildeSclice";

export const store = configureStore({
  reducer: {
    setting: settingReducer,
    modal: modal,
    section: section,
    customFormBuilder,
  },
});
